package pl.decks.chartjs.radar

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.radar.builder.RadarConfigBuilder
import pl.decks.chartjs.radar.dataset.RadarDataSet
import pl.decks.chartjs.radar.options.RadarOptions
import pl.decks.chartjs.style.ChartLabel

data class RadarConfig(
    val labels: List<ChartLabel>,
    val datasets: List<RadarDataSet>,
    val options: RadarOptions = RadarOptions(),
) : ChartJSOption {
    companion object {
        operator fun invoke(labels: List<ChartLabel>, block: RadarConfigBuilder.() -> Unit): RadarConfig
        = RadarConfigBuilder(labels).apply(block).build()
    }
    override fun toChartJs(): dynamic = jso {
        this.type = "radar".asDynamic()
        this.data = jso {
            this.labels = labels
                .map { it.toChartJs() }
                .toTypedArray()
                .asDynamic()
            this.datasets = datasets
                .map { it.toChartJs() }
                .toTypedArray()
                .asDynamic()
        }
        this.options = options.toChartJs()
    }
}
